import { useEffect, useState } from "react";
import styled from "styled-components";
import { BoxButtonTitle, FlexColBetweenBox, InputTitle } from "../../style/common";
import { flexUnsetStart } from "../../style/mixins";
import TitleAndInput from "../common/TitleAndInput";
import ContentBtns from "./ContentBtns";
import { memberChangePw, memberInfo, memberSignout } from "../../api/member";
import { useAlertStore } from "../../store/alertStore";
import { formatToNational } from "../../utils/phoneFormatChange";
import { stringToJson } from "../../utils/stringToJson";
import { dateHyphen } from "../../utils/dateFormChange";
import { fileApiService } from "../../api/apiService";
import { useNavigatePage } from "../../hooks/useNavigatePage";
import { Spinner } from "../common/Spinner";

interface ContentProps {
  useIdx: string;
}

export default function Content({ useIdx }: ContentProps) {
  const setAlert = useAlertStore((state) => state.setAlert);
  const { onMovementPage } = useNavigatePage();
  const [memberData, setMemberData] = useState<MemberSignupInput>();
  const [memberImg, setMemberImg] = useState<string | null>(null);
  const [memberImgfile, setMemberImgfile] = useState<string | null>(null);
  const [memberClientOs, setMemberClientOs] = useState<string | null>(null);
  const [memberClientAppVersion, setMemberClientAppVersion] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const params = { idx: useIdx };
        const response = await memberInfo(params);
        const data = response.data;
        const memberPublicExtra = data.member_public_extras ? stringToJson(data.member_public_extras) : {};
        
        if (data.files && data.files[0]?.file_url) {
          const getFilesResponse = await fileApiService.get<Blob>(data.files[0].file_url, {
            responseType: "arraybuffer" as ResponseType,
          });
          const imgUrlBlob = new Blob([getFilesResponse], { type: "image/jpeg" });
          const objectUrl = URL.createObjectURL(imgUrlBlob);
          setMemberImgfile(objectUrl);
          setMemberImg(data.files[0]?.file_url || null);
        }

        setMemberClientOs(data.member_client_os || "");
        setMemberClientAppVersion(data.member_client_app_version || "");

        setMemberData({
          id: data.member_id || "",
          pw: "초기화시 a123456789!",
          img: "",
          name: data.member_name || "",
          phone: data.member_phone ? formatToNational(data.member_phone, "KR") : "",
          com: memberPublicExtra.com || "",
          sub: memberPublicExtra.sub || "",
          team: memberPublicExtra.team || "",
          com_email: memberPublicExtra.com_email || "",
          sub_email: memberPublicExtra.sub_email || "",
          date_active: data.date_active ? dateHyphen(data.date_active, "YYYY-MM-DD") : "-",
          login_ip: data.member_login_ip || "접속 IP 없음",
          date_login: data.date_login ? dateHyphen(data.date_login, "YYYY-MM-DD HH:mm") : "최근 접속 기록 없음",
          date_delete: data.date_delete ? dateHyphen(data.date_delete, "YYYY-MM-DD HH:mm") : "-",
          date_block: data.date_block ? dateHyphen(data.date_block, "YYYY-MM-DD HH:mm") : "-",
        });
      }
      catch (error: any) {}
    };

    fetchUserInfo();
  }, [useIdx]);

  const pwResetClick = async () => {
    try {
      // eslint-disable-next-line no-restricted-globals
      if (confirm("비밀번호를 초기화 하시겠습니까?")) {
        const newPw = "a123456789!";
        const memberChangePwProps = { idx: useIdx, member_pw: newPw };
        
        const response = await memberChangePw(memberChangePwProps);

        if (response.statusCode === 200) {
          setAlert("비밀번호가 초기화되었습니다.", "green");
        }
      }
    } catch (error) {}
  };

  const memberSignoutClick = async () => {
    try {
      // eslint-disable-next-line no-restricted-globals
      if (confirm("회원을 탈퇴 시키겠습니까?")) {
        const signoutPropsData = { idx: useIdx };
        const response = await memberSignout(signoutPropsData);

        if (response.statusCode === 200) {
          setAlert("회원 탈퇴가 완료되었습니다.", "green");
          onMovementPage("/user");
        }
      }
    } catch (error) {}
  };

  return (
    <FlexColBetweenBox>
      <div>
        <BoxButtonTitleCustom>
          회원상세
          <ContentBtns 
            idx={useIdx}
            pwResetOnClick={pwResetClick}
            signoutOnClick={memberSignoutClick}
          />
        </BoxButtonTitleCustom>

        {memberData ? (
          <>
            <InputGridBox>
              <TitleAndInput
                title="아이디(이메일)"
                type="none"
                value={memberData.id}
              />
              <TitleAndInput
                title="비밀번호"
                type="none"
                value={memberData.pw}
              />
              
              <UserImgBox>
                <InputTitle>회원사진</InputTitle>
                <ImgLayout>{memberImg ? <MemberImg src={memberImgfile || memberImg} /> : "등록한 이미지 없음"}</ImgLayout>
              </UserImgBox>

              <TitleAndInput
                title="이름"
                type="none"
                value={memberData.name}
              />
              <TitleAndInput
                title="휴대폰 번호"
                type="none"
                value={memberData.phone}
              />

              <TitleAndInput
                title="회사명"
                type="none"
                value={memberData.com}
              />
              <TitleAndInput
                title="현장명"
                type="none"
                value={memberData.sub}
              />
              <TitleAndInput
                title="팀명"
                type="none"
                value={memberData.team}
              />

              <TitleAndInput
                title="본사 메일"
                type="none"
                value={memberData.com_email}
              />
              <TitleAndInput
                title="원청사 메일"
                type="none"
                value={memberData.sub_email}
              />
              <TitleAndInput
                title="회원가입일"
                type="none"
                value={memberData.date_active}
              />
            </InputGridBox>

            <InputGridBox>
              <TitleAndInput
                title="IP"
                type="none"
                value={memberData.login_ip}
              />
              <TitleAndInput
                title="최근접속일"
                type="none"
                value={memberData.date_login}
              />
              <div></div>

              <TitleAndInput
                title="탈퇴일자"
                type="none"
                value={memberData.date_delete}
              />
              <TitleAndInput
                title="차단일자"
                type="none"
                value={memberData.date_block}
              />
              <TitleAndInput
                title="OS"
                type="none"
                value={memberClientOs || ""}
              />
              <TitleAndInput
                title="앱버전"
                type="none"
                value={memberClientAppVersion || ""}
              />
            </InputGridBox>
          </>
        ) : <Spinner />}
      </div>
{/* 
      <CommonFooter>
        <div></div>
        <ContentBtns 
          idx={useIdx}
          pwResetOnClick={pwResetClick}
          signoutOnClick={memberSignoutClick}
        />
      </CommonFooter> */}
    </FlexColBetweenBox>
  );
}

const BoxButtonTitleCustom = styled(BoxButtonTitle)`
  margin-bottom: 2.5rem;
`;

const InputGridBox = styled.div`
  width: 100%;
  padding-bottom: 2.5rem;
  border-bottom: 1px solid #DEE2E6;
  margin-bottom: 2.5rem;
  display: grid;
  grid-template-columns: repeat(3, 326px);
  gap: 0.75rem 5%;
`;

const UserImgBox = styled.div`
  ${flexUnsetStart};
  grid-row: span 3;

  h6 {
    margin-top: 0.5rem;
  }
`;

const MemberImg = styled.img`
  width: auto;
  height: 120px;
`;  

const ImgLayout = styled.div`
  padding-left: 1rem;
`;
